import axios from 'axios'
import axiosRetry from 'axios-retry'
import { AccessToken } from './authUtils'

const axiosInstance = axios.create()

axiosRetry(axiosInstance, {
  retries: 3,
  retryDelay: (retryCount) => {
    return axiosRetry.exponentialDelay(retryCount)
  },
  retryCondition: (error) => {
    // Only retry on server errors (5xx) and network errors
    const resStatus = error.response?.status
    return resStatus === undefined || resStatus >= 500
  },
  onRetry: (retryCount, error, requestConfig) => {
    if (requestConfig.headers) {
      delete requestConfig.headers.authorization
      Object.assign(requestConfig.headers, AccessToken.requestHeaders())
    }
  }
})

export default axiosInstance
